import React, { Component, Fragment, useState } from 'react';
import { NavItem, NavLink, DropdownItem, DropdownMenu, DropdownToggle, Dropdown } from 'reactstrap';
import { Link } from 'react-router-dom';
import authService from './AuthorizeService';
import { ApplicationPaths } from './ApiAuthorizationConstants';

export class LoginMenu extends Component {
    constructor(props) {
        super(props);

        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.state = {
            dropdownOpen: false,
            isAuthenticated: false,
            userName: null
        };
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
    }

    async populateState() {
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        var dropdownOpen = false;
        this.setState({
            dropdownOpen,
            isAuthenticated,
            userName: user && user.name
        });
    }

    render() {
        const { dropdownOpen, isAuthenticated, userName } = this.state;
        if (!isAuthenticated) {
            const registerPath = `${ApplicationPaths.Register}`;
            const loginPath = `${ApplicationPaths.Login}`;
            return this.anonymousView(registerPath, loginPath);
        } else {
            const profilePath = `${ApplicationPaths.Profile}`;
            const logoutPath = { pathname: `${ApplicationPaths.LogOut}`, state: { local: true } };
            return this.authenticatedView(userName, profilePath, logoutPath);
        }
    }

    toggleDropdown() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    authenticatedView(userName, profilePath, logoutPath) {

        return (<Fragment>
 
            <Dropdown nav isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown}>
                <DropdownToggle nav caret>
                    {this.state.userName}
                </DropdownToggle>
                <DropdownMenu className="">
                    <DropdownItem tag={Link} className="text-dark" to={logoutPath}>Uitloggen</DropdownItem>
                </DropdownMenu>
            </Dropdown>

        </Fragment>);

    }

    anonymousView(registerPath, loginPath) {
        return (<Fragment>
 
            <NavItem>
                <NavLink tag={Link} className="text-dark" to={loginPath}>Inloggen</NavLink>
            </NavItem>
        </Fragment>);
    }
}
